var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnBubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 89,
    viewBox: "0 0 154 89",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.60465L5.13333 3.74419C10.2667 5.88372 20.5333 6.42636 30.8 5C41.0667 3.57364 51.3333 0.178295 61.6 1.60465C71.8667 3.03101 81.2333 5.78682 91.5 6.5C101.767 7.21318 112.933 5.88372 123.2 2.31783C133.467 -1.24806 143.733 0.178295 148.867 0.891473L154 1.60465V89H148.867C143.733 89 133.467 89 123.2 89C112.933 89 102.667 89 92.4 89C82.1333 89 71.8667 89 61.6 89C51.3333 89 41.0667 89 30.8 89C20.5333 89 10.2667 89 5.13333 89H0V1.60465Z",
    fill: "url(#paint0_linear_2947_2756)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 14,
    r: 5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 34,
    r: 5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 24,
    r: 5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 31,
    r: 4,
    fill: "white",
    fillOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 29,
    r: 4,
    fill: "white",
    fillOpacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 13,
    r: 5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 28.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 26.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 11.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 21.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 8.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 21.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 29.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 47,
    r: 4,
    fill: "white",
    fillOpacity: 0.3
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 41.5,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2947_2756",
    x1: 8.9722e-7,
    y1: 40.6531,
    x2: 154,
    y2: 40.6531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014D90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#029BBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBubbles);
export default __webpack_public_path__ + "static/media/btn_bubbles.d312ea26eec2fc5ed4d878e3e099fa7b.svg";
export { ForwardRef as ReactComponent };